// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './router/index';
import request from "./utils/request.js"
import store from "./store"

import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';

import '../theme-chalk/index.css'
import './common/font/font.css'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor);

Vue.use(ElementUI)

Vue.config.productionTip = false

Vue.prototype.$http = request

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js